// action
import {
    SAVE_ARTICLE_BOOKMARK,
    SAVE_ARTICLE_BOOKMARK_FAIL,
    SAVE_ARTICLE_BOOKMARK_SUCCESS,
    SAVE_ARTICLE_BOOKMARK_RESET
} from '../action/saveArticleBookmarkAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "", 
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SAVE_ARTICLE_BOOKMARK:
            return {
                ...state,
                apiState: "loading"
            }
        case SAVE_ARTICLE_BOOKMARK_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case SAVE_ARTICLE_BOOKMARK_SUCCESS:
            return {
                ...state,
                apiState: "success",
                message: action.response.data.message,
            }
        case SAVE_ARTICLE_BOOKMARK_RESET:
            return initialState
        default:
            return state
    }
}